import axios from 'axios';

function getTours (clientId) {
  return axios.get('api/client/' + clientId + '/tours/');
}

function getTopics (tourId) {
  return axios.get('api/tour/' + tourId + '/topics');
}

// function getAllexportData () {
//   return axios.get('api/client/getAllexportData');
// }

function copyTourToNewTours (tourId) {
  return axios.get('api/copyTourToNewTours/' + tourId);
}

function changeToursImagesServices (data, toursId) {
  let formData = new FormData();
  formData.append('image', data);
  formData.append('toursId', toursId);
  return axios.post('api/changeToursImagesServices/' + toursId, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

function deleteTours (clientId, tourIds) {
  return axios.delete('api/client/' + clientId + '/tours/delete', {
    params: {
      tourIds: tourIds
    }
  });
}

function deteleQueueJob (exportId) {
  console.log('DeteleQueueJob(): exportId = ');
  console.log(exportId);
  return axios.delete('api/client/deteleQueueJob', {
    params: {
      exportId: exportId
    }
  });
}

function reStartQueueJobApi (jobID) {
  return axios.get('api/client/reStartQueueJob', {
    params: {
      jobID: jobID
    }
  });
}

export {
  getTours,
  getTopics,
  deleteTours,
  copyTourToNewTours,
  changeToursImagesServices,
  // getAllexportData,
  deteleQueueJob,
  reStartQueueJobApi
};



// WEBPACK FOOTER //
// ./src/services/ToursService.js